import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { first, merge, Observable, of, Subscription } from "rxjs";
import { environment } from "src/environments/environment";
import { HTTP_ENDPOINTS } from "../external/http";
import { NewNoteDto } from "../models/new-note-dto";
import { NoteDto } from "../models/note-dto";
import { OrderDto, PutOrderDto } from "../models/order-dto";

@Injectable({
  providedIn: "root",
})
export class OrderService {
  private orders: OrderDto[] = [];
  private orders$: EventEmitter<OrderDto[]> = new EventEmitter();
  private fecthOrdersSubscription?: Subscription;

  constructor(private http: HttpClient) {}

  public refreshOrders(): void {
    this.fecthOrdersSubscription?.unsubscribe();
    this.fecthOrdersSubscription = this.fetchOrders().subscribe((orders) => {
      this.orders = orders;
      this.orders$.emit(orders);
    });
  }

  public getOrders$(): Observable<OrderDto[]> {
    if (this.orders.length > 0) return merge(of(this.orders), this.orders$);

    return this.orders$;
  }

  private fetchOrders(): Observable<OrderDto[]> {
    return this.http
      .get<
        OrderDto[]
      >(`${environment.apiBasePath}/${HTTP_ENDPOINTS.ORDERS_PATH}`)
      .pipe(first());
  }

  public updateOrder(putOrderDto: PutOrderDto): Observable<OrderDto> {
    return this.http
      .put<OrderDto>(
        `${environment.apiBasePath}/${HTTP_ENDPOINTS.ORDERS_PATH}`,
        putOrderDto
      )
      .pipe(first());
  }

  public deleteOrder(orderId: string): Observable<void> {
    return this.http
      .delete<void>(
        `${environment.apiBasePath}/${HTTP_ENDPOINTS.ORDERS_PATH}/${orderId}`
      )
      .pipe(first());
  }

  public addNote(orderId: string, newNoteDto: NewNoteDto): Observable<NoteDto> {
    return this.http
      .post<NoteDto>(
        `${environment.apiBasePath}/${HTTP_ENDPOINTS.ORDERS_PATH}/${orderId}/${HTTP_ENDPOINTS.ORDER_NOTES_PATH}`,
        newNoteDto
      )
      .pipe(first());
  }
}
